export default __webpack_public_path__ + "static/media/customer-card.300bf05d.svg";